
import React from 'react';

const AboutSection = () => {
  return (
    <section className="bg-ai-dark py-16 px-4">
      <div className="container mx-auto max-w-4xl text-center">
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">
          AI World Congress 2026
        </h2>
        <p className="text-lg md:text-xl text-gray-300 mb-8">
          Experience AI Conference London - AI World Congress 2026, November 25th-26th, in the heart of London in the High Street Kensington
        </p>
        <p className="text-lg text-gray-300">
          Join us for insightful sessions, cutting-edge demos, and unparalleled networking opportunities.
        </p>
      </div>
    </section>
  );
};

export default AboutSection;
